import { NgModule } from '@angular/core';
import { UiEntityTableCellDirective } from './ ui-entity-table-cell-directive';

@NgModule({
  declarations: [UiEntityTableCellDirective],
  exports: [UiEntityTableCellDirective],
})
export class DirectivesModule {}
